var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"overlay__short-caption"},[_c('h2',[_c('span',{staticClass:"overlay__short-caption__text balance-text",attrs:{"data-overlay-prevent-close":""},domProps:{"innerHTML":_vm._s(_vm.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }